<template>
  <div class="chat-input" @click="onClick">
    <div
      class="input-area"
      contenteditable="true"
      @input="onInput"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
      ref="inputArea"
      :placeholder="placeholder"
    ></div>
<!--  :style="userListStyle"  -->
    <div v-if="showUserList" class="user-list" >
      <ul>
        <li
          v-for="(user, index) in filteredUsers"
          ref="userEl"
          :key="user.id"
          :class="{ selected: index === selectedUserIndex }"
          @mousedown.prevent="selectUser(user)"
        >
          {{ user.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { messageSearchService } from '@/store/chat/chat-api'
import { mapGetters } from 'vuex'

export default {
  name: 'ChatInput',
  props: {
    placeholder: String,
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showUserList: false,
      mentionQuery: '',
      filteredUsers: [],
      selectedUserIndex: 0,
      editingMentionNode: null,
      userListStyle: {},
    };
  },
  mounted() {
    // Устанавливаем начальное значение из пропса
    //this.setContent(this.value);
  },
  watch: {
    value(newVal) {
      // Синхронизируем содержимое при изменении значения
      if (!this.isComposing) {
        //this.setContent(newVal);
      }
    },
    selectedUserIndex(index) {
      const el = this.$refs.userEl[index];
      if(el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  },
  computed: {
    users() {
      return this.members.map((user) => {
        return {
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
        }
      });
    },
    ...mapGetters('chat', ['members', 'membersGrouped']),
  },
  methods: {
    setContent(value) {
      this.$refs.inputArea.innerHTML = value;
      /*const div = document.createElement('div');
      div.innerHTML = value;
      this.$refs.inputArea.appendChild(div);*/
    },
    onInput(event) {
      // Обработка ввода
      this.emitInput();
      // Остальная логика...
      // (Сохраните предыдущую реализацию метода onInput)
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        this.range = selection.getRangeAt(0).cloneRange();
      }

      if (this.editingMentionNode) {
        const mentionText = this.editingMentionNode.textContent;
        this.mentionQuery = mentionText;
        this.filteredUsers = this.users.filter((user) =>
          user.name.toLowerCase().includes(this.mentionQuery.toLowerCase())
        );
        this.showUserList = this.filteredUsers.length > 0;
      } else {
        const text = this.getTextBeforeCursor();
        const atIndex = text.lastIndexOf('@');

        if (atIndex >= 0) {
          const query = text.slice(atIndex + 1);
          this.mentionQuery = query;

          // Фильтруем список пользователей
          this.filteredUsers = this.users.filter((user) =>
            user.name.toLowerCase().includes(query.toLowerCase())
          );

          this.showUserList = this.filteredUsers.length > 0;
        } else {
          this.showUserList = false;
          this.mentionQuery = '';
        }
      }
    },
    onKeyUp(event) {
      // Обработка удаления символов
      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.onInput(event);
      }
    },
    selectUser(user) {
      if (this.editingMentionNode) {
        // Заменяем существующее упоминание
        this.editingMentionNode.textContent = user.name;
        this.editingMentionNode.setAttribute('data-user-id', user.id);
        this.editingMentionNode.style.color = '#003882';

        // Перемещаем курсор после упоминания
        const range = document.createRange();
        range.setStartAfter(this.editingMentionNode);
        range.collapse(true);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        this.editingMentionNode = null;
      } else if (this.range) {
        const selection = window.getSelection();
        let range = selection.getRangeAt(0);

        // Находим текстовый узел и смещение
        let node = range.startContainer;
        let offset = range.startOffset;

        // Ищем символ '@' в текущем узле
        let atPosition = this.findAtPosition(node, offset);

        if (atPosition === null) {
          // Если символ '@' не найден, ничего не делаем
          return;
        }

        // Создаем новый диапазон для замены текста от '@' до текущей позиции курсора
        const newRange = document.createRange();
        newRange.setStart(node, atPosition);
        newRange.setEnd(node, offset);

        // Удаляем текст после '@'
        newRange.deleteContents();

        // Создаем узел упоминания
        const mentionNode = document.createElement('span');
        mentionNode.textContent = user.name;
        mentionNode.style.color = '#003882'; // Цвет упоминания
        mentionNode.setAttribute('data-user-id', user.id); // Сохраняем ID пользователя

        // Вставляем упоминание
        newRange.insertNode(mentionNode);

        // Вставляем пробел после упоминания
        const spaceNode = document.createTextNode('\u00A0'); // Неразрывный пробел
        newRange.setStartAfter(mentionNode);
        newRange.collapse(true);
        newRange.insertNode(spaceNode);

        // Перемещаем курсор после пробела
        newRange.setStartAfter(spaceNode);
        newRange.collapse(true);
        selection.removeAllRanges();
        selection.addRange(newRange);
      }

      // Скрываем список пользователей
      this.showUserList = false;
      this.mentionQuery = '';
      this.filteredUsers = [];
      this.selectedUserIndex = 0;

      // Эмитим обновленное значение
      this.emitInput();
    },
    onKeyDown(event) {
      if (this.showUserList) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (this.selectedUserIndex < this.filteredUsers.length - 1) {
            this.selectedUserIndex++;
          }
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (this.selectedUserIndex > 0) {
            this.selectedUserIndex--;
          }
        } else if (event.key === 'Enter') {
          event.preventDefault();
          this.selectUser(this.filteredUsers[this.selectedUserIndex]);
        } else if (event.key === 'Escape') {
          this.showUserList = false;
          this.editingMentionNode = null;
        }
      }
    },
    getTextBeforeCursor() {
      const selection = window.getSelection();
      if (!selection.rangeCount) return '';
      const range = selection.getRangeAt(0);
      const preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(this.$refs.inputArea);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      return preCaretRange.toString();
    },
    findAtPosition(node, offset) {
      // Ищем последний символ '@' перед курсором в текущем узле
      const text = node.textContent.slice(0, offset);
      const atIndex = text.lastIndexOf('@');
      return atIndex >= 0 ? atIndex : null;
    },
    onClick(event) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        this.range = selection.getRangeAt(0).cloneRange();
      }

      // Проверяем, кликнули ли по упоминанию
      let node = event.target;
      if (node.hasAttribute('data-user-id')) {
        event.preventDefault(); // Предотвращаем перемещение курсора внутрь упоминания
        this.editingMentionNode = node;

        // Позиционируем список пользователей рядом с упоминанием
        const rect = node.getBoundingClientRect();
        this.userListStyle = {
          top: rect.bottom + 'px',
          left: rect.left + 'px',
          position: 'fixed',
        };

        // Заполняем mentionQuery и показываем список пользователей
        this.mentionQuery = node.textContent;
        /*this.filteredUsers = this.users.filter((user) =>
          user.name.toLowerCase().includes(this.mentionQuery.toLowerCase())
        );*/
        this.filteredUsers = this.users;
        this.showUserList = this.filteredUsers.length > 0;

        // Устанавливаем курсор после упоминания
        const range = document.createRange();
        range.setStartAfter(node);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        // Кликнули вне упоминания
        this.showUserList = false;
        this.editingMentionNode = null;
      }
    },
    getMessage() {
      // Метод для получения текстового значения с упоминаниями
      let message = '';
      const childNodes = this.$refs.inputArea.childNodes;
      childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          message += node.textContent;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.hasAttribute('data-user-id')) {
            message += `@${node.textContent}`;
          } else {
            message += node.textContent;
          }
        }
      });
      return message;
    },
    emitInput() {
      // Эмитим событие input с текущим содержимым
      const value = this.$refs.inputArea.innerHTML;
      this.$emit('input', value);
    },
    addText(text) {
      this.$refs.inputArea.innerHTML += text;
    },
    clean() {
      this.$refs.inputArea.innerHTML = '';
    }
  },
};
</script>

<style scoped>
.chat-input {
  position: relative;
  flex-grow: 1;
}

.input-area {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.input-area:focus {
  outline: none;
}

.user-list {
  max-height: 150px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  z-index: 1000;
}

.user-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.user-list li {
  padding: 8px 10px;
  cursor: pointer;
}

.user-list li.selected,
.user-list li:hover {
  background: #f0f0f0;
}


/*----*/
.input-area {
  min-height: unset;
  height: 35px;
  border: none;
  padding: 0;
}
.input-area[contenteditable=true]:empty:not(:focus):before{
  content:attr(placeholder);
  color:grey;
  font-style:italic;
}
.user-list {
  position: absolute;
  bottom: 100%;
  box-shadow: 0px 12px 21px rgba(180, 187, 198, 0.19);
  border: none;
  border-radius: 5px;
  background: #ffffff;
}
</style>





